var _style, _g, _g2, _g3, _g4, _g5, _g6, _text, _text2, _text3, _text4, _text5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFig1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 570 800",
    style: {
      enableBackground: "new 0 0 570 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#1E1E1C;stroke-miterlimit:10;}\r\n\t.st1{fill:#B2B2B2;}\r\n\t.st2{fill:#B2B2B2;stroke:#70706F;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;stroke:#70706F;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#70706F;stroke-miterlimit:10;}\r\n\t.st5{opacity:0.49;}\r\n\t.st6{fill:#FFFFFF;stroke:#1E1E1C;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#1E1E1C;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#1E1E1C;stroke-width:0.25;stroke-miterlimit:10;stroke-dasharray:5.9304,5.9304;}\r\n\t.st9{fill:#1E1E1C;}\r\n\t.st10{fill:none;stroke:#1E1E1C;stroke-width:0.25;stroke-miterlimit:10;stroke-dasharray:6.0125,6.0125;}\r\n\t.st11{fill:none;stroke:#1E1E1C;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st12{fill:none;stroke:#1F71B8;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st13{fill:#1F71B8;}\r\n\t.st14{fill:none;stroke:#009640;stroke-miterlimit:10;}\r\n\t.st15{fill:none;stroke:#1F71B8;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st16{fill:none;stroke:#1F71B8;stroke-width:0.25;stroke-miterlimit:10;stroke-dasharray:2.9784,2.9784;}\r\n\t.st17{opacity:0.5;fill:#1F71B8;stroke:#2A3180;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st18{opacity:0.5;fill:#009640;stroke:#056734;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st19{opacity:0.5;fill:#E95C0C;stroke:#E5352B;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st20{fill:#E8501D;stroke:#BE1823;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st21{fill:#009739;stroke:#056734;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st22{fill:none;stroke:#3D3D3B;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st23{fill:none;stroke:#E8501D;stroke-miterlimit:10;}\r\n\t.st24{font-family:'MyriadPro-Regular';}\r\n\t.st25{font-size:23.9151px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.73,103.25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.94,258.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.29,82.4l-8.06,26.92l-6.97,45.49l11.51,22.95l25.45,13.41L268.27,224l16.49,28.97l2.3,5.15 l11.77,3.73h8.4l8.07-2.19l6.15-5.79l10.45-19.68l7.63-10.6l13.83-28.08l1.5-3.2l23.71-14.54l12.63-24.51l-8.46-46.01 l-6.72-24.84l-5.82,14.85l-25.25,13.63l-4.61,17.09c0,0-8.5,3.96-10.43,4.96c-11.74,6.06-54.31-0.16-54.31-0.16 s-7.15-0.45-9.02-2.85c-2.87-3.66-3.78-19.44-3.78-19.44l-26.92-12.03L230.29,82.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M310.62,315.64c-2.2,0.35-4.85,0.55-7.72,0.55c-2.18,0-4.24-0.12-6.07-0.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.69,277.04c-2.2,0.35-4.85,0.55-7.72,0.55c-2.18,0-4.24-0.12-6.07-0.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M422.29,216.48c0,0-32.13,26.85-44.4,38.54c-2.9,2.76-4.69,4.68-4.69,5.2c0,2.73-63.62,16.36-63.62,16.36 v39.08l18.18,10l34.54,34.54l37.27-2.73l73.62-131.79l42.72-61.81l7.27-55.19l-77.26-62.06l-69.99,29.99l3.44,12.13l5.65,19.94 l7.27,46.1l-9.55,18.37l-2.26,4.35c5.45,1.82,20,12.72,20,12.72l-5.45,36.36l-25.2,17.27l5.17,13.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M394.46,278.65l6.36,21.81l-19.09,33.63c0,0-41.81-19.09-41.81-21.81s-0.91-12.72,0-13.63 c0.91-0.91,20.9-20,20.9-20H394.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M183.44,217.11c0,0,32.13,26.85,44.4,38.54c2.9,2.76,4.69,4.68,4.69,5.2c0,2.73,63.62,16.36,63.62,16.36 v39.08l-18.18,10l-34.54,34.54l-37.27-2.73l-73.62-131.79l-42.72-61.81l-7.27-55.19l77.26-62.06l69.99,29.99l-3.44,12.13 l-5.65,19.94l-7.27,46.1l9.55,18.37l2.26,4.35c-5.45,1.82-20,12.72-20,12.72l5.45,36.36l25.2,17.27l-5.17,13.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M211.62,279.03l-6.36,21.81l19.09,33.63c0,0,41.81-19.09,41.81-21.81s0.91-12.72,0-13.63 c-0.91-0.91-20.91-20-20.91-20H211.62z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "380.83,177.76 354.85,192.3 339.53,225.02 319.02,257.74  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "287.06,258.12 266.56,225.4 251.23,192.68 225.25,178.14  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286.45,257.2c4.04,3.02,9.97,4.92,16.58,4.92c6.58,0,12.49-1.89,16.53-4.89"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "375.99,77.31 369.88,95.91 343.27,110.12 339.23,126.59  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M339.24,126.59c0,5.23-16.22,9.47-36.22,9.47s-36.22-4.24-36.22-9.47l-4.01-16.1L236.35,96.6l-6.07-18.18"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M116.79,510.8L82.55,360.45L58.62,319.2v-30.03l30.3-37.63l11.51,17.5l13.33,3.64l14.19-14.54 c-0.2-1.53-0.3-3.09-0.3-4.67c0-19.72,15.99-35.71,35.71-35.71s35.71,15.99,35.71,35.71s-15.99,35.71-35.71,35.71l-12.63,2.28 L138,306.37l-0.61,9.82l-5.45,44.64l24.24,149.97"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 164.2,
    y1: -12.49,
    x2: 164.2,
    y2: -9.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 164.2,
    y1: -3.56,
    x2: 164.2,
    y2: 456.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 164.2,
    y1: 459.02,
    x2: 164.2,
    y2: 462.02
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "164.2,463.78 163.19,461.29 164.2,461.89 165.22,461.29  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: -11.82,
    y1: 252.5,
    x2: -8.82,
    y2: 252.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "-2.81,252.5 469.55,252.5 523.28,252.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 526.29,
    y1: 252.5,
    x2: 529.29,
    y2: 252.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M530.8,252.5c-0.71,0.26-1.59,0.71-2.14,1.19l0.43-1.19l-0.43-1.19 C529.21,251.79,530.09,252.24,530.8,252.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 303.27,
    y1: 437.86,
    x2: 302.81,
    y2: 254.13
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "308.81,433.63 303.27,436.01 297.71,433.66 303.29,446.82  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 148.75,
    y1: 125.06,
    x2: 88.92,
    y2: 251.53
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 148.75,
    y1: 125.06,
    x2: 93.45,
    y2: 241.96
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "88.92,251.53 89.79,235.44 93.78,241.24 100.81,240.65  "
  })))), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 164.2,
    y1: 253.47,
    x2: 102.03,
    y2: 223.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 91.05,
    y1: 248.01,
    x2: 91.69,
    y2: 246.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 92.95,
    y1: 243.96,
    x2: 213.34,
    y2: -13.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 213.97,
    y1: -15.09,
    x2: 214.61,
    y2: -16.45
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M88.92,253.49l27,0c0,0,0-10-3-17c-2.62-6.12-11-13-11-13L88.92,253.49z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M30.62,115.19l-7.63-10.5h4.08l3.46,4.76c0.76,1.21,1.66,2.51,2.56,3.68h0.18c0.81-1.17,1.71-2.51,2.47-3.73 l3.23-4.71h3.95L35.2,115.5l8.35,11h-4.13l-3.77-5.03c-0.94-1.21-1.93-2.69-2.87-3.95h-0.18c-0.9,1.3-1.8,2.6-2.69,4l-3.59,4.98 h-3.95L30.62,115.19z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 106.77,
    y: 205.69,
    transform: "matrix(0.906 0.4233 -0.4233 0.906 103.3426 -29.8316)",
    className: "st18",
    width: 24.12,
    height: 24.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.03,
    y: 253.47,
    className: "st19",
    width: 32.06,
    height: 32.06
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M197.33,272.21c0,8.9-5.42,13.65-12.03,13.65c-6.88,0-11.66-5.33-11.66-13.16c0-8.22,5.09-13.62,12.01-13.62 C192.73,259.08,197.33,264.5,197.33,272.21z M177.18,272.62c0,5.55,3.01,10.52,8.3,10.52c5.32,0,8.31-4.89,8.31-10.78 c0-5.16-2.69-10.55-8.27-10.55C179.95,261.8,177.18,266.95,177.18,272.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M233.59,209.67c2.4-0.39,5.24-0.65,8.31-0.65c5.6,0,9.61,1.33,12.26,3.8c2.71,2.45,4.28,5.95,4.28,10.83 c0,4.96-1.55,8.98-4.35,11.77c-2.86,2.82-7.54,4.36-13.4,4.36c-2.8,0-5.12-0.11-7.11-0.34V209.67z M237.52,236.44 c0.99,0.16,2.44,0.18,3.93,0.18c8.38,0.02,12.89-4.65,12.89-12.83c0.05-7.15-3.99-11.66-12.24-11.66c-2.02,0-3.54,0.19-4.58,0.4 V236.44z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M155.05,206.35v26.27c0,1.93,0.07,4.1,0.18,5.6h-3.51l-0.2-3.75h-0.11c-1.21,2.43-3.82,4.25-7.36,4.25 c-5.26,0-9.32-4.45-9.32-11.03c-0.03-7.26,4.47-11.67,9.75-11.67c3.33,0,5.58,1.56,6.55,3.29h0.09v-12.96H155.05z M151.12,225.34 c0-0.51-0.05-1.17-0.17-1.69c-0.61-2.49-2.74-4.54-5.72-4.54c-4.09,0-6.53,3.59-6.53,8.36c0,4.41,2.19,8.07,6.45,8.07 c2.64,0,5.04-1.78,5.77-4.74c0.14-0.52,0.19-1.07,0.19-1.69V225.34z"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 89.01,
    y1: 253.47,
    x2: 164.3,
    y2: 253.47
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M336.98,446.71l-7.67-30.26h4.14l3.6,15.31c0.87,3.78,1.68,7.53,2.22,10.46h0.11c0.49-3,1.44-6.61,2.46-10.5 l4.06-15.26h4.05l3.7,15.33c0.84,3.62,1.66,7.19,2.12,10.38h0.1c0.6-3.31,1.44-6.69,2.39-10.45l4-15.26h4.01l-8.58,30.26h-4.08 l-3.81-15.74c-0.96-3.9-1.59-6.84-2-9.9h-0.09c-0.5,3.04-1.21,5.98-2.33,9.89l-4.28,15.75H336.98z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M61.92,216.44h16.3v3.26H65.85v10.07h11.43v3.23H65.85v13.69h-3.93V216.44z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 164.41,
    y1: 253.47,
    x2: 439.18,
    y2: 253.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 164.2,
    y1: 253.47,
    x2: 301.8,
    y2: 253.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 148.75,
    cy: 125.06,
    r: 6.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 39.52,
    y1: 126.59,
    x2: 148.75,
    y2: 125.06
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M83.13,662.72l-6.35-25.07h3.43l2.99,12.69c0.72,3.14,1.39,6.24,1.84,8.67h0.09 c0.41-2.49,1.19-5.48,2.04-8.71l3.37-12.65h3.36l3.07,12.71c0.7,3,1.37,5.96,1.76,8.6h0.08c0.5-2.75,1.2-5.54,1.98-8.66 l3.32-12.64h3.33l-7.11,25.07h-3.38l-3.16-13.05c-0.79-3.23-1.32-5.67-1.66-8.2h-0.07c-0.42,2.51-1,4.95-1.93,8.2l-3.55,13.05 H83.13z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M83.8,695.96h13.5v2.7H87.05v8.35h9.47v2.68h-9.47v11.35H83.8V695.96z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M99.35,752.02v21.77c0,1.6,0.06,3.4,0.15,4.64h-2.91l-0.17-3.11h-0.09c-1,2.01-3.17,3.52-6.1,3.52 c-4.36,0-7.72-3.69-7.72-9.14c-0.03-6.01,3.7-9.67,8.08-9.67c2.76,0,4.62,1.29,5.43,2.73h0.07v-10.74H99.35z M96.1,767.76 c0-0.43-0.04-0.97-0.14-1.4c-0.51-2.06-2.27-3.76-4.74-3.76c-3.39,0-5.41,2.97-5.41,6.92c0,3.65,1.82,6.69,5.35,6.69 c2.19,0,4.18-1.48,4.78-3.93c0.12-0.43,0.16-0.89,0.16-1.4V767.76z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M102.62,535.69c0,7.38-4.49,11.31-9.97,11.31c-5.7,0-9.66-4.41-9.66-10.91c0-6.81,4.22-11.29,9.95-11.29 C98.8,524.81,102.62,529.31,102.62,535.69z M85.92,536.03c0,4.6,2.5,8.72,6.88,8.72c4.41,0,6.89-4.05,6.89-8.93 c0-4.28-2.23-8.75-6.85-8.75C88.21,527.07,85.92,531.33,85.92,536.03z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.66,593.68l-6.32-8.71h3.39l2.86,3.94c0.63,1,1.38,2.08,2.12,3.05h0.15c0.67-0.97,1.41-2.08,2.05-3.09 l2.68-3.91h3.27l-6.4,8.97l6.92,9.11h-3.42l-3.12-4.17c-0.78-1-1.6-2.23-2.38-3.27H90.3c-0.74,1.08-1.49,2.16-2.23,3.31 l-2.98,4.13h-3.27L88.66,593.68z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 117.5722 545.5032)",
    className: "st9 st24 st25"
  }, "- centre of the femur head")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 117.8818 600.3079)",
    className: "st9 st24 st25"
  }, "- centre of abductor muscles\u2019  attachment")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 118.0839 660.972)",
    className: "st9 st24 st25"
  }, "- body weight in N")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 117.7778 716.1686)",
    className: "st9 st24 st25"
  }, "- cumulative force of abductors in N")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 117.2997 778.1234)",
    className: "st9 st24 st25"
  }, "- abductors\u2019 lever arm in cm")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFig1);
export default __webpack_public_path__ + "static/media/fig1.ab5032faac43fcd21fe51d60b60024d3.svg";
export { ForwardRef as ReactComponent };